module.exports = __webpack_public_path__ + "static/img/foundation-8m-x-1m_256.14e7bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/foundation-8m-x-1m_256.png
// module id = HUst
// module chunks = 0